(function () {
  'use strict';

  var ROOT_SELECTOR = 'product-info.index-product--partner';
  var INLINE_PURCHASE_SELECTOR = '[data-partner-inline-purchase]';
  var INLINE_ADD_SELECTOR = '.product__partner-add-to-cart[data-add-to-cart]';
  var STICKY_PURCHASE_SELECTOR = '[data-partner-sticky-purchase]';
  var STICKY_ADD_SELECTOR = '[data-partner-sticky-add-to-cart]';
  var VISIBLE_CLASS = 'is-visible';
  var MOBILE_MEDIA = '(max-width: 749px)';
  var READY_FLAG = '__pmPartnerProductReady';

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function choosePreferredSmall(root) {
    var sizeWrapper = root.querySelector('[data-partner-option-kind="size"]');
    if (!sizeWrapper) return;
    var candidates = Array.prototype.slice.call(sizeWrapper.querySelectorAll('[data-partner-option-value]'));
    var small = candidates.find(function (candidate) {
      var value = candidate.getAttribute('data-value') || candidate.value || '';
      var unavailable = candidate.disabled || candidate.classList.contains('disabled') || candidate.getAttribute('aria-disabled') === 'true';
      return String(value).toLowerCase() === 'small' && !unavailable;
    });
    if (!small || small.checked || small.getAttribute('aria-current') === 'true') return;
    if (small.matches('input')) {
      small.checked = true;
      small.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      small.click();
    }
  }

  function initStickyPurchase(root) {
    var inlinePurchase = root.querySelector(INLINE_PURCHASE_SELECTOR);
    var inlineAdd = root.querySelector(INLINE_ADD_SELECTOR);
    var stickyPurchase = root.querySelector(STICKY_PURCHASE_SELECTOR);
    var stickyAdd = root.querySelector(STICKY_ADD_SELECTOR);
    if (!inlinePurchase || !inlineAdd || !stickyPurchase || !stickyAdd) return;

    var mobile = window.matchMedia(MOBILE_MEDIA);
    var inlineVisible = true;

    function syncState() {
      stickyAdd.disabled = inlineAdd.disabled;
      ['is-loading', 'is-added'].forEach(function (name) {
        stickyAdd.classList.toggle(name, inlineAdd.classList.contains(name));
      });
    }

    function syncVariant(payload) {
      var data = payload && payload.data;
      if (!data || String(data.sectionId || '') !== String(root.dataset.section || '')) return;
      var price = stickyPurchase.querySelector('[data-product-price]');
      if (price && data.variant && typeof data.variant.price === 'number' && window.theme && typeof window.theme.formatMoney === 'function') {
        price.textContent = window.theme.formatMoney(data.variant.price, window.theme.moneyFormat);
      }
      window.requestAnimationFrame(syncState);
    }

    function updateVisibility() {
      var visible = mobile.matches && !inlineVisible && !document.documentElement.hasAttribute('data-scroll-locked');
      stickyPurchase.classList.toggle(VISIBLE_CLASS, visible);
      stickyPurchase.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.documentElement.style.setProperty('--partner-sticky-purchase-height', visible ? stickyPurchase.offsetHeight + 'px' : '0px');
    }

    stickyAdd.addEventListener('click', function (event) {
      event.preventDefault();
      if (!stickyAdd.disabled) inlineAdd.click();
    });

    var intersection = new IntersectionObserver(function (entries) {
      inlineVisible = Boolean(entries[0] && entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2);
      updateVisibility();
    }, { threshold: [0, 0.2, 1] });
    intersection.observe(inlinePurchase);

    new MutationObserver(syncState).observe(inlineAdd, { attributes: true, attributeFilter: ['class', 'disabled'] });
    new MutationObserver(updateVisibility).observe(document.documentElement, { attributes: true, attributeFilter: ['data-scroll-locked'] });
    if (mobile.addEventListener) mobile.addEventListener('change', updateVisibility);
    else mobile.addListener(updateVisibility);
    window.addEventListener('resize', updateVisibility);
    if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, syncVariant);
    }
    syncState();
    updateVisibility();
  }

  function initPartnerProduct(root) {
    if (!root || root[READY_FLAG]) return;
    root[READY_FLAG] = true;
    initStickyPurchase(root);
    window.requestAnimationFrame(function () { choosePreferredSmall(root); });
  }

  function init(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    if (target.matches && target.matches(ROOT_SELECTOR)) initPartnerProduct(target);
    target.querySelectorAll(ROOT_SELECTOR).forEach(initPartnerProduct);
  }

  document.addEventListener('theme:product-info:loaded', function (event) { init(event.target); });
  ready(function () { init(document); });
})();
